<template>
  <div>
    <v-card>
      <v-card-title>
        <v-icon color="black">attach_money</v-icon>
        <h2>Point</h2>
      </v-card-title>
      <hr />
      <v-card-text>
        <div
          class="scorll-panel"
          v-infinite-scroll="loadMore"
          infinite-scroll-disabled="busy"
          infinite-scroll-distance="10"
        >
          <v-data-table :headers="headers" :items="pointManageData.user_points" hide-actions>
            <template v-slot:items="props">
              <td class="text-xs-center">{{ props.item.user_point_order_id }}</td>
              <td class="text-xs-center">{{ props.item.user_point_value }}</td>
              <td class="text-xs-center">{{ props.item.user_point_province_id }}</td>
              <td class="text-xs-center">{{ props.item.user_point_type }}</td>
            </template>
          </v-data-table>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
export default {
  props: ["pointManageData", "eachCustomer"],
  data() {
    return {
      busy: false,
      headers: [
        {
          text: "Point Order Id",
          align: "center",
          sortable: false,
          value: "user_point_order_id"
        },
        {
          text: "Point",
          align: "center",
          sortable: false,
          value: "user_point_value"
        },
        {
          text: "Point Province",
          align: "center",
          sortable: false,
          value: "user_point_province_id"
        },
        {
          text: "Point Type",
          align: "center",
          sortable: false,
          value: "user_point_type"
        }
      ]
    };
  },
  methods: {
    loadMore() {
      this.busy = true;
      let configPath = {
        tel: this.eachCustomer.user_tel,
        countPoint: this.pointManageData.user_points.length,
        countPointExchange: this.pointManageData.user_point_exchanges.length
      };
      if (
        this.pointManageData.user_points.length <
        this.pointManageData.user_point_ranged
      ) {
        this.$emit("fetchPointList", {
          configPath,
          type: "point",
          isFirsttime: false
        });
        this.busy = false;
      }
    }
  }
};
</script>
<style scoped>
.scorll-panel {
  width: 100%;
  height: 300px;
  overflow: auto;
}
</style>
